import { ArrowDownIcon } from "@talladega/icons";
import { getPrefixUrl } from "@modules/api/api";
import { ExtendedWarrantyRatesResponse } from "@modules/purchase/warranty/types/ExtendedWarrantyRates";
import { IAExtendedWarrantyPrograms } from "@modules/purchase/warranty/types/IAProgram";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

type Props = {
  extWarrantyRates: ExtendedWarrantyRatesResponse;
};

const getAftermarketBrochureLink = (
  locale: string,
  programId: string,
  coverageTypes: string[]
) => {
  const coverageTypesQuery = coverageTypes.join(",");
  const rawUrl = `${getPrefixUrl()}/api/purchases/aftermarket/brochure/${programId}?lang=${locale}&coverageTypes=${coverageTypesQuery}`;

  return rawUrl.replace(/%2C/g, ",");
};

const WarrantyBrochure = ({ extWarrantyRates }: Props) => {
  const { t } = useTranslation(["common", "purchase"]);

  const router = useRouter();
  const locale = router.locale || "en";

  const iaProgram = IAExtendedWarrantyPrograms.find(
    (p) => p.id === extWarrantyRates?.productDetails?.programId
  );

  const distinctUsedCoverageTypeIds = extWarrantyRates?.coverages.reduce<
    string[]
  >((acc, current) => {
    if (!acc.some((coverage) => coverage === current.type)) {
      acc.push(current.type);
    }
    return acc;
  }, []);

  const handleWarrantyBrochureClick = (
    e: React.MouseEvent<HTMLAnchorElement>
  ) => {
    e.preventDefault();

    const brochureLink = getAftermarketBrochureLink(
      locale,
      iaProgram?.id ?? "",
      distinctUsedCoverageTypeIds ?? []
    );

    window.open(brochureLink, "_blank");
  };

  return (
    <div className="mt-8 flex items-center justify-between rounded-md bg-gray-50 p-4">
      <div className="px-2">
        <p className="text-lg font-semibold text-[#0C2340]">
          {t("purchase:explore_coverage_details")}
        </p>
        <p className="mt-2 text-sm font-normal text-gray-800">
          {t("purchase:download_pdf_description")}
        </p>
      </div>

      <a
        href="#"
        onClick={handleWarrantyBrochureClick}
        className="hover:text-primary-hover flex items-center gap-1 font-medium text-primary-500 underline"
      >
        {t("purchase:download_pdf")}
        <ArrowDownIcon className="h-4 w-4 text-primary-500" />
      </a>
    </div>
  );
};

export default WarrantyBrochure;
